import requests from "./httpService";

const ForceCheckoutTimeServices = {
    getForceCheckoutTime(id, body) {
        return requests.get(`/force_checkout_time/all?company_id=${id}`, body);
    },

    deleteForceCheckoutTime(id, body) {
        return requests.delete(`/force_checkout_time/${id}`, body);
    },
    createForceCheckoutTime(body) {
        return requests.post(`/force_checkout_time/create`, body);
    },
    editForceCheckoutTime(id, body) {
        return requests.post(`/force_checkout_time/update/${id}`, body);
    },
};

export default ForceCheckoutTimeServices;
